module.exports = __webpack_public_path__ + "svgs/coupon-2.7c22ac70.svg";